import { render, staticRenderFns } from "./ViewSingleApplication.vue?vue&type=template&id=5054dcd6"
import script from "./ViewSingleApplication.vue?vue&type=script&lang=js"
export * from "./ViewSingleApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports